import { BehaviorSubject, Observable } from 'rxjs';
import { SettingsWebPortal } from '../Models/Settings/SettingsWebportal';
import { SettingsWebportalHelper } from '../Helpers/SettingsWebportalHelper';
import { SoundData } from '../Models/Settings/SoundData';
import { IMessageSock } from '../Models/WebSocket/IMessageSock';
import { WebSocketMessageTypeIncoming } from '../Enums/WebSocketMessageTypeIncoming';
import { authService, webSocketService } from '../App';
import { MessageWebSocketIncoming } from '../Models/WebSocket/MessageWebSocketIncoming';
import { WsRefreshWebPortalSetting } from '../Models/WebSocket/Incoming/WsRefreshWebportalSetting';

import { v4 as uuidv4 } from 'uuid';

export class SettingsWebportalService {
  public notificationToRefresh: BehaviorSubject<SettingsWebPortal>;

  public FetchingReadySubject: BehaviorSubject<boolean>;
  public FetchingReady!: boolean;

  public sessionInBrowserId!: string;

  public setting!: SettingsWebPortal;
  constructor() {
    this.notificationToRefresh = new BehaviorSubject<SettingsWebPortal>(
      new SettingsWebPortal(),
    );
    this.FetchingReadySubject = new BehaviorSubject<boolean>(false);

    this.sessionInBrowserId = uuidv4();

    this.FetchItems(false);

    webSocketService.messagesChannel.subscribe((value) => {
      this.HandleWebsockets(value);
    });
  }

  public GetFetchStatus(): Observable<boolean> {
    this.FetchItems();
    return this.FetchingReadySubject;
  }

  private async FetchItems(forceUpdate: boolean = false) {
    if (!this.FetchingReady || forceUpdate) {
      this.FetchingReady = true;

      this.setting = await SettingsWebportalHelper.GetSetting();
      this.FetchingReadySubject.next(true);
    }
  }

  private HandleWebsockets(msg: IMessageSock) {
    const prodItem = Object.assign(new MessageWebSocketIncoming(), msg);

    if (
      prodItem.Type == WebSocketMessageTypeIncoming.WsRefreshWebPortalSetting
    ) {
      var newSetting: WsRefreshWebPortalSetting = Object.assign(
        new WsRefreshWebPortalSetting(),
        msg,
      );

      if (newSetting.SessionInBrowserId == this.sessionInBrowserId) {
        return;
      }

      this.setting = newSetting.SettingWebportal;
      this.notificationToRefresh.next(newSetting.SettingWebportal);
    }
  }

  public async GetSetting(forceUpdate: boolean = false) {
    if (!this.FetchingReady || forceUpdate) {
      await this.FetchItems(true);
    }

    return this.setting;
  }

  public async GetSettingUpdated() {
    this.setting = await SettingsWebportalHelper.GetSetting();
    return this.setting;
  }

  public SafeSetting(item: SettingsWebPortal) {
    SettingsWebportalHelper.UpdateSetting(item, authService.GetToken());
  }

  public RemoveSound(item: SoundData) {
    SettingsWebportalHelper.RemoveSound(item, authService.GetToken());
  }

  public async ExportSetting() {
    let token = authService.GetToken();
    await SettingsWebportalHelper.ExportSetting(await this.GetSetting(), token);
  }
}
